// @ts-nocheck

(() => {
  "use strict";

  const EL = (globalThis.EspacioLaserV2 =
    globalThis.EspacioLaserV2 || {});

  class EngravingDOMAdapter {
    constructor(root) {
      if (!(root instanceof Element)) {
        throw new Error(
          "[EspacioLaserV2] DOMAdapter requiere un elemento raíz."
        );
      }

      this.root = root;
      this.removeOldContentWrapper();
      this.elements = this.collectElements();
    }

    /*
     * Elimina el wrapper interno creado durante las pruebas anteriores.
     * El texto vuelve a ser hijo directo del objeto principal.
     */
    removeOldContentWrapper() {
      const content = this.root.querySelector(
        "[data-engraving-content]"
      );

      if (!content) return;

      const parent = content.parentElement;

      while (content.firstChild) {
        parent.insertBefore(
          content.firstChild,
          content
        );
      }

      content.remove();
    }

    collectElements() {
      const find = (selector) =>
        this.root.querySelector(selector);

      const object = find(
        "[data-engraving-object]"
      );

      if (!object) {
        throw new Error(
          "[EspacioLaserV2] No se encontró [data-engraving-object]."
        );
      }

      return {
        root: this.root,
        object,

        previewText: find(
          "[data-engraving-preview-text]"
        ),

        textInput: find(
          "[data-engraving-text-input]"
        ),

        rotateHandle: find(
          "[data-engraving-rotate-handle]"
        ),

        scaleHandle: find(
          "[data-engraving-scale-handle]"
        ),

        expandButton: find(
          "[data-engraving-expand]"
        ),

        closeButton: find(
          "[data-engraving-close]"
        ),

        saveButton: find(
          "[data-engraving-save]"
        ),

        inputs: {
          positionX: find(
            "[data-engraving-position-x]"
          ),

          positionY: find(
            "[data-engraving-position-y]"
          ),

          rotation: find(
            "[data-engraving-rotation]"
          ),

          scale: find(
            "[data-engraving-scale]"
          ),
        },
      };
    }

    readInitialState() {
      const {
        object,
        previewText,
        textInput,
        inputs,
      } = this.elements;

      const text =
        textInput?.value ||
        (
          previewText &&
          !previewText.classList.contains(
            "is-placeholder"
          )
            ? previewText.textContent.trim()
            : ""
        );

      return {
        content: {
          type: "text",
          text,
          lines: [],
          icon: null,
        },

        transform: {
          x: this.readNumber(
            object.dataset.x ??
              inputs.positionX?.value,
            0
          ),

          y: this.readNumber(
            object.dataset.y ??
              inputs.positionY?.value,
            0
          ),

          rotation: this.readNumber(
            object.dataset.rotation ??
              inputs.rotation?.value,
            0
          ),

          scale: this.readScale(
            object.dataset.scale ??
              inputs.scale?.value,
            1
          ),
        },

        appearance: {
          font: object.dataset.font || "default",
          side: object.dataset.side || "front",
          alignment: "center",
        },

        constraints: {
          keepInsideBounds: true,
        },

        ui: {
          selected: false,
          dragging: false,
          rotating: false,
          scaling: false,
          expanded: false,
        },
      };
    }

    readNumber(value, fallback = 0) {
      const parsed = Number.parseFloat(
        String(value ?? "")
      );

      return Number.isFinite(parsed)
        ? parsed
        : fallback;
    }

    readScale(value, fallback = 1) {
      if (
        typeof value === "string" &&
        value.includes("%")
      ) {
        return (
          this.readNumber(
            value,
            fallback * 100
          ) / 100
        );
      }

      return this.readNumber(
        value,
        fallback
      );
    }

    writeDataset(transform) {
      const object = this.elements.object;

      object.dataset.x = String(transform.x);
      object.dataset.y = String(transform.y);
      object.dataset.rotation = String(
        transform.rotation
      );
      object.dataset.scale = String(
        transform.scale
      );
    }

    writeHiddenInputs(state) {
      const { inputs } = this.elements;
      const { x, y, rotation, scale } =
        state.transform;

      this.setValue(
        inputs.positionX,
        this.round(x, 2)
      );

      this.setValue(
        inputs.positionY,
        this.round(y, 2)
      );

      this.setValue(
        inputs.rotation,
        this.round(rotation, 2)
      );

      this.setValue(
        inputs.scale,
        `${this.round(scale * 100, 1)}%`
      );
    }

    setValue(input, value) {
      if (!input) return;

      input.value = String(value ?? "");
    }

    round(value, decimals) {
      const factor = 10 ** decimals;

      return (
        Math.round(value * factor) /
        factor
      );
    }
  }

  EL.EngravingDOMAdapter =
    EngravingDOMAdapter;
})();